import { apiSlice } from 'store/slices/api/api-slice';

export const notificationEnum = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        notificationType: builder.query<string[], void>({
            query: () => ({
                url: '/notification/notification-type-enum',
                method: 'GET',
            }),
        }),

        notificationGroup: builder.query<string[], void>({
            query: () => ({
                url: '/notification/notification-group-enum',
                method: 'GET',
            }),
        }),

        notificationIconName: builder.query<string[], void>({
            query: () => ({
                url: '/notification/notification-icon-name-enum',
                method: 'GET',
            }),
        }),

        notificationUserStatus: builder.query<string[], void>({
            query: () => ({
                url: '/notification/notification-receiver-status-enum',
                method: 'GET',
            }),
        }),

        notificationStatus: builder.query<string[], void>({
            query: () => ({
                url: '/notification/notification-status-enum',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useNotificationTypeQuery,
    useNotificationGroupQuery,
    useNotificationIconNameQuery,
    useNotificationUserStatusQuery,
    useNotificationStatusQuery,
} = notificationEnum;
